import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {ErrorToaster} from "../../../../shared/toaster";
import '../log.css'
import moment from "moment/moment";
import {LoadingState} from "../../../../components/fouladyar/loading-state/loadingState";

const UnhealthyAccounts = () => {
    const auth = useSelector((state) => state.auth);
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);


    async function getUnhealthyAccounts() {
        try {
            setIsLoading(true)
            const today = moment().startOf('day').format('YYYY-MM-DD');  // Start of today (midnight)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/log/meta-api-account-status?date=${today.toString()}`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200 || !res.data.statusCode) {
                console.log('unhealthy-accounts', res.data.data)
                setData(res.data.data.logs[0].extras)
                // setSelectedVarietyId(res.data.data.varieties[0]?._id);
            }

            setIsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }

    }


    useEffect(() => {
        getUnhealthyAccounts();
        // Set up interval to call the function every 10 seconds
        const interval = setInterval(() => {
            getUnhealthyAccounts();
        }, 10000);

        // Cleanup the interval on component unmount
        return () => clearInterval(interval);
    }, []);


    return (
        <React.Fragment>

            <div className="nk-content ">
                <div className="container-fluid select-plan-container">

                    <h1>{"لاگ اکانت های مشکل دار"}</h1>


                    <div className="spacer"/>
                    <h3>
                        در این صفحه لاگ اکانت هایی که مشکل اتصال به متا دارند قابل مشاهده است.
                    </h3>
                    <p>
                        دقت کنید که هر حساب دارای دو شرایط است. یکی وضعیت deployment و دیگری وضعیت connection. هر دو حالت در لاگ زیر قابل مشاهده خواهد بود
                    </p>



                    <pre className={"log-container"}>
                         {
                             isLoading ? <LoadingState/> :
                                 <code>
                                     {JSON.stringify(data, null, 2)}
                                 </code>
                         }

                    </pre>

                </div>
            </div>
        </React.Fragment>

    );
};

export default UnhealthyAccounts;
